import { NgModule } from '@angular/core'
import { UcBlockedContentReplacerComponent } from './uc-blocked-content-replacer.component'
import { CmsComponentsBaseModule } from '../cms-components-base.module'
import { MbI18nModule } from '../../../translations/mb-i18n.module'
import { LinkModule } from '../shared/link/link.module'

@NgModule({
  declarations: [
    UcBlockedContentReplacerComponent
  ],
  imports: [
    CmsComponentsBaseModule,
    MbI18nModule,
    LinkModule,
  ],
  exports: [
    UcBlockedContentReplacerComponent
  ]
})
export class UcBlockedContentReplacerModule {
}
